unit SchadenEdit;

interface

uses
  System.SysUtils, System.Classes, System.StrUtils, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Storage,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Imaging.GIFImg, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  XData.Web.Client, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.WebCtrls, VCL.TMSFNCPageControl, VCL.TMSFNCTabSet,
  VCL.TMSFNCListBox, WEBLib.Lists, WEBLib.SignatureCapture, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WebBasis2, VCL.TMSFNCPanel, VCL.TMSFNCButton, Vcl.Mask,
  WEBLib.Mask;

[async] function DoSchadenEdit( var aID_Schaden, aID_Fahrzeug : Integer ) : TModalResult; async;

type
  TfrmSchadenEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbSchadenCaption: TLabel;
    lbBeladung: TLabel;
    lbEntladung: TLabel;
    [async]
    pgContr: TTMSFNCPageControl;
    tabDaten: TTMSFNCPageControlContainer;
    mBeschreibung: TMemo;
    tabDoku: TTMSFNCPageControlContainer;
    ImgContr: TImageControl;
    lbDokumentPos: TLabel;
    fpFilePicker: TFilePicker;
    cbxBilder: TComboBox;
    btnBildDel: TTMSFNCToolBarButton;
    edtSchadenRef: TLabel;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavPrev: TTMSFNCToolBarButton;
    lbMitarbeiter: TLabel;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    btnAkt: TTMSFNCToolBarButton;
    btnDownload: TTMSFNCToolBarButton;
    lbFahrzeug: TLabel;
    edtDatum: TDateTimePicker;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    edtUhrzeit: TMaskEdit;
    WebLabel3: TLabel;
    lbStatus: TLabel;
    lbSchadensart: TLabel;
    WebLabel6: TLabel;
    WebLabel4: TLabel;
    procedure fpFilePickerChange(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
     //
    [async]  procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnBildDelClick(Sender: TObject); async;
    [async] procedure fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string); async;
    [async] procedure Daten_Laden; async;
    [async] function  Daten_Speichern : Integer; async;
    [async] procedure Bilder_Laden; async;
    [async] procedure Bild_Anzeigen; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure btnAktClick(Sender: TObject); async;
    [async] procedure btnPdfClick(Sender: TObject); async;
     //
    procedure DoDokumentNav(Sender: TObject);
    procedure pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
    procedure cbxBilderChange(Sender: TObject);
    procedure ImgContrDblClick(Sender: TObject);
    procedure btnOKClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);

  private
    iID_Schaden  : Integer;
    iID_Fahrzeug : Integer;
    sAktBild : String;
    sDokTyp : String;
    sIDMandLand : String;
    function Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;


  public
    iID_Tau : Integer;
  protected procedure LoadDFMValues; override; end;

var frmSchadenEdit: TfrmSchadenEdit;

const cFormSchadenEdit = 'SCHADENEDIT_';

implementation

{$R *.dfm}

uses UnitMain, Konstanten, GlobalWeb , SpediFucsDatenmodul, ShowGrafik ;


//================================================================================================//

function DoSchadenEdit( var aID_Schaden, aID_Fahrzeug : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmSchadenEdit := TfrmSchadenEdit.Create(application);
  frmSchadenEdit.Popup   := True;
  frmSchadenEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmSchadenEdit.iID_Schaden  := aID_Schaden;
  frmSchadenEdit.iID_Fahrzeug := aID_Fahrzeug;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmSchadenEdit, frmSchadenEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmSchadenEdit.Resize;

  Try
    await( TModalResult, frmSchadenEdit.Execute);  // excute form and wait for close

    Result := frmSchadenEdit.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
console.log('1 Daten_Speichern');
        await( frmSchadenEdit.Daten_Speichern );
        aID_Schaden := frmSchadenEdit.iID_Schaden;
      End;
//
  Finally
    frmSchadenEdit.Free;
  End;


  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Opt_Speichern;
begin

  TLocalStorage.SetValue( cFormSchadenEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Opt_Laden;
begin
  pgContr.ActivePageIndex := StrToIntDef( TLocalStorage.GetValue( cFormSchadenEdit+'PAGE' )  ,0);

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.btnOKClick(Sender: TObject);
begin
  inherited;

console.log( 'btnOKClick' ) ;

  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;




end;

//====================================================================================================================//

procedure TfrmSchadenEdit.btnPdfClick(Sender: TObject);
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sBildDatei : String;
    aObj : TParam;
    iID : Integer;
    am : TMemoryStream;
    mr : TModalResult;
begin
  inherited;

  If cbxBilder.ItemIndex = -1 then Exit;
  If cbxBilder.Items.Count = 0 then Exit;

  sBildDatei := cbxBilder.Text;

  If not WaitMessage.Showing then WaitMessage.Show;



  aObj := TParam.Create;
  aObj.String1 := c_Schaden;
  aObj.String2 := sBildDatei;
  aObj.Integer1  := self.iID_Schaden ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_Bild', [aObj] ));
  ClientConn.Free;

  aObj.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);

  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;


  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Bild konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      am := TMemoryStream.Create;
        TTMSFNCUtils.LoadStreamFromBase64( sDaten, am );
      am.SaveToFile(sBildDatei);
      am.Free;
    End;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Bilder_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL, aSL_Daten : TStringList;
    i, iAnz, iAnzDok  : Integer;
    aObj : TParam;
    aArray : TArray<string>;
begin


  If not WaitMessage.Showing then WaitMessage.Show;

  aObj := TParam.Create;
  aObj.String1 := c_Schaden;
  aObj.Integer1  := self.iID_Schaden ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.Get_Bilder', [ aObj ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aObj.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := sDaten;

  console.log(aSL_Daten.Text);

  cbxBilder.Items.clear;

  For i := 0 to aSL_Daten.Count -1 Do
    Begin
       sTmp := aSL_Daten[i];
       cbxBilder.Items.Add( aSL_Daten[i] )
    End;

  iAnzDok := cbxBilder.Items.Count;
  cbxBilder.Enabled   := (iAnzDok>0);
  cbxBilder.Enabled := (iAnzDok>0);

  lbDokumentPos.Caption := '0/0';

  If iAnzDok > 0 then
    Begin
      cbxBilder.ItemIndex :=  (iAnzDok-1);
      lbDokumentPos.Caption := IntToStr( cbxBilder.ItemIndex+1 ) +'/' +IntToStr( cbxBilder.Items.Count );
    End;

  aSL.Free;
  aSL_Daten.Free;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.btnAktClick(Sender: TObject);
begin
  await(  Bilder_Laden );
  await(  Bild_Anzeigen );
end;

//====================================================================================================================//

procedure TfrmSchadenEdit.btnBildDelClick(Sender: TObject);
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    Blob: JSValue;
    sImgBase64, sDaten, sBildDatei : String;
    iID, iErg : Integer;
    res: TModalResult;
    aObj : TParam;
begin


  If cbxBilder.ItemIndex = -1 then Exit;
  If cbxBilder.Items.Count = 0 then Exit;

  Res := await(TModalResult, MessageDlgAsync('Bild löschen ?', mtConfirmation, [mbYes, mbNo]));
  If Res <> mrYes then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  sBildDatei := cbxBilder.Text;

  aObj := TParam.Create;
  aObj.String1 := c_Schaden;
  aObj.String2 := sBildDatei;
  aObj.Integer1  := self.iID_Schaden ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
   Response := await( ClientConn.RawInvokeAsync('ISystemService.Del_Bild', [aObj] ));
  ClientConn.Free;

  aObj.Free;

  cbxBilder.Items.Delete(cbxBilder.ItemIndex);
  cbxBilder.ItemIndex :=  cbxBilder.Items.Count-1;

  ImgContr.Clear;

  await( Bild_Anzeigen );

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.cbxBilderChange(Sender: TObject);
begin
  inherited;
  Bild_Anzeigen;
end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sInfo, sKopfZeile: String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
    li: TListItem;
begin

  console.log('TfrmSchadenEdit.Daten_Laden - Start '+IntToStr(self.iID_Schaden) );

  If not WaitMessage.Showing then WaitMessage.Show;


  sSQL := '01:SELECT S.ID_SCHADEN, S.REF_NR, S.ID_FAHRZEUG, S.ID_MITARBEITER, S.DATUM, S.UHRZEIT, S.BESCHREIB, S.ID_DOK_BEZ, '
            +' (SELECT KENNZEICHEN FROM FAHRZEUG F WHERE F.ID_FAHRZEUG=S.ID_FAHRZEUG) as KENNZ, '
            +' (SELECT BEZEICHNUNG FROM STATUS ST WHERE ST.ID_STATUS=S.ID_STATUS) as STATUS_BEZ, '
            +'  (SELECT BEZEICHNUNG FROM SCHADENART SA WHERE SA.ID_SCHADENART=S.ID_SCHADENART) as SCHADENSART, '

            + ' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
            +'   FROM ADRESSE A, MITARBEITER M  '
            +'   WHERE A.ID_ADRESSE=M.ID_ADRESSE AND M.ID_MITARBEITER=S.ID_MITARBEITER ) as MAB '

            +' FROM SCHADEN S WHERE S.ID_SCHADEN='+IntToStr(self.iID_Schaden) +';'

        +'02:SELECT KENNZEICHEN FROM FAHRZEUG F WHERE ID_FAHRZEUG='+IntToStr(self.iID_Fahrzeug) +';'

        +'03:SELECT ID_LAND FROM MANDANT M, ADRESSE A WHERE M.ID_ADRESSE=A.ID_ADRESSE;'
        ;
  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  mBeschreibung.Clear;


  // Schaden ---------------------------------------------------------
  //
  If self.iID_Schaden = 0 then
    Begin
      lbSchadenCaption.Caption := 'Schaden anlegen...';
      edtDatum.DateTime := Date;
      edtUhrzeit.Text := FormatDateTime('hh:nn', Now );

      lbMitarbeiter.Caption := frmMainForm.BenutzerMaZuname+', '+frmMainForm.BenutzerMaVorname;

      edtSchadenRef.Caption := '';
      lbStatus.Caption := '';
      lbSchadensart.Caption := '';
      iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '02');
      sFelder := aSL[1];
      sDaten  := aSL[2];
      lbFahrzeug.Caption := GetFeldWert( sFelder, sDaten, 'KENNZEICHEN'  );
      lbFahrzeug.Tag     := self.iID_Fahrzeug ;
    End
  Else
    Begin
      lbSchadenCaption.Caption := 'Schaden bearbeiten...';

      iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

      sFelder := aSL[1];
      sDaten  := aSL[2];

      self.iID_Fahrzeug := SToI( GetFeldWert( sFelder, sDaten, 'ID_FAHRZEUG'  ));
      lbFahrzeug.Tag    := self.iID_Fahrzeug ;

      edtSchadenRef.Caption :=  GetFeldWert( sFelder, sDaten, 'REF_NR'  );
      lbFahrzeug.Caption := GetFeldWert( sFelder, sDaten, 'KENNZ'  );

      edtDatum.Date := StrToDateTime(  GetFeldWert( sFelder, sDaten, 'DATUM' )  );
      edtUhrzeit.Text :=  GetFeldWert( sFelder, sDaten, 'UHRZEIT' );

      lbMitarbeiter.Caption := GetFeldWert( sFelder, sDaten, 'MAB'  );
      lbStatus.Caption := GetFeldWert( sFelder, sDaten, 'STATUS_BEZ'  );
      lbSchadensart.Caption := GetFeldWert( sFelder, sDaten, 'SCHADENSART'  );

      sTmp := GetFeldWert( sFelder, sDaten, 'BESCHREIB'  );
      mBeschreibung.Text := ReplaceStr( sTmp, '##', chr(13)+chr(10) );

      console.log(  GetFeldWert( sFelder, sDaten, 'BESCHREIB') );

    End;

  // Land Mandant -----------------------------------------------------
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '03');
  sFelder := aSL[1];
  sDaten  := aSL[2];
  sIDMandLand := GetFeldWert( sFelder, sDaten, 'ID_LAND'  );


  // Dokumente -----------------------------------------------------------------
  await( Bilder_Laden );
  If pgContr.ActivePageIndex = 1 then  await(  Bild_Anzeigen );


  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  console.log('TfrmSchadenEdit.Daten_Laden - Ende '+IntToStr(self.iID_Schaden) );

end;

//================================================================================================//

function TfrmSchadenEdit.Daten_Speichern : Integer;
var Response : TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sSQL : String;
    aObj : TParam;
    iErg : Integer;
begin


  If self.iID_Schaden=0 then
    Begin
      aObj := TParam.Create;
      aObj.ID_Fahrzeug := self.iID_Fahrzeug;

       ClientConn := TXDataWebClient.Create(nil);
       ClientConn.Connection := frmMainForm.XDataConn;

       Response := await( ClientConn.RawInvokeAsync('ISystemService.SchadenIns', [ aObj] ));

       iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

       self.iID_Schaden := iErg;

      ClientConn.Free;

      console.log('angelegt...' +Inttostr(self.iID_Schaden)   );

    End;


  sSQL := 'UPDATE SCHADEN SET '
        +' DATUM = '+cH+DateTimeToStr(edtDatum.DateTime)+cH  +', '
        +' ID_MITARBEITER = '+frmMainForm.BenutzerMaNr  +', '
        +' UHRZEIT = '+cH+Trim(edtUhrzeit.Text)+cH +', '
        +' BESCHREIB = '+cH+Trim(mBeschreibung.Text)+cH  +', '
        +' INS_USER = '+  cH+  frmMainForm.User_Account +cH
        +' WHERE ID_SCHADEN='+IntToStr(self.iID_Schaden)
        +';' ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  sSQL := await( Crypt( sSQL ));

  Response := await( ClientConn.RawInvokeAsync('ISystemService.SetDatenPaket', [ sSQL ] ) );
  Blob := Response.Result;

  ClientConn.Free;

  console.log(sSQL + 'upgedatet...');

end;


//====================================================================================================================//

procedure TfrmSchadenEdit.DoDokumentNav(Sender: TObject);
var iIdx, iAnz : Integer;
begin

  If cbxBilder.Items.Count=0 then Exit;

  iIdx := cbxBilder.ItemIndex;
  Inc(iIdx);
  iAnz := cbxBilder.Items.Count;

  If Sender = btnNavNext then
    Begin
      If iIdx = iAnz then Exit;
      cbxBilder.ItemIndex := cbxBilder.ItemIndex +1;
    End
  Else
    Begin
      If iIdx = 1 then Exit;
      cbxBilder.ItemIndex := cbxBilder.ItemIndex -1;
    End;

  Bild_Anzeigen;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.fpFilePickerChange(Sender: TObject);
begin
  fpFilePicker.Files[0].GetFileAsBase64;
end;

//====================================================================================================================//

procedure TfrmSchadenEdit.fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
var sBase64, sBildDatei, sExt : String;
    aFile : TFile;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    aObj : TParam;
begin


  If self.iID_Schaden=0 then  await( Daten_Speichern);


  aFile :=  fpFilePicker.Files[AFileIndex];
  sExt := UpperCase( ExtractFileExt(aFile.Name) );

  console.log( sExt );

  If (sExt='.PNG') or (sExt='.JPG') or (sExt='.JPEG') or (sExt='.BMP')  then
    Begin
      sBase64 := c_ImgVorsatz + ABase64;
      ImgContr.url := sBase64;
    End;


  sBildDatei := aFile.Name;
  sBildDatei := 'B'+IntToStr(self.iID_Schaden)+'_'+FormatDateTime('yymmdd_hhnnss', Now)   + sExt ;

  console.log( sBildDatei );

  aObj := TParam.Create;
  aObj.String1  := c_Schaden;
  aObj.String2  := sBildDatei;
  aObj.String3  := aBase64;
  aObj.Integer1 := self.iID_Schaden ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_Bild', [ aObj ] ));
  ClientConn.Free;

  TFile(fpFilePicker.Files[AFileIndex]).Name := sBildDatei;

  await( Daten_Laden );

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Bild_Anzeigen;
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    aObj : TParam;
    Blob: JSValue;
    sImgBase64, sDaten, sExt : String;
    sBildDatei : String;
    mr : TModalResult;
begin

  If cbxBilder.Items.Count=0 then lbDokumentPos.Caption := '0/0';

  If cbxBilder.ItemIndex = -1 then Exit;
  If cbxBilder.Items.Count = 0 then Exit;

  sBildDatei := cbxBilder.Text;

  // Bild schon geladen ?
  If sBildDatei = sAktBild then Exit;

  // Grafik-Format ?
  sExt := UpperCase( ExtractFileExt( sBildDatei ) );
  If (sExt<>'.JPG') and (sExt<>'.JPEG') and (sExt<>'.PNG') and (sExt<>'.BMP') and (sExt<>'.GIF') then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  aObj := TParam.Create;
  aObj.String1 := c_Schaden;
  aObj.String2 := sBildDatei;
  aObj.Integer1  := self.iID_Schaden ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_Bild', [aObj] ));
  ClientConn.Free;

  aObj.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);

  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;


  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Bild konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      sImgBase64 := c_ImgVorsatz + sDaten;
      ImgContr.URL := sImgBase64;
    End;

  sAktBild := sBildDatei;

  lbDokumentPos.Caption := IntToStr( cbxBilder.ItemIndex+1 ) +'/' +IntToStr( cbxBilder.Items.Count );

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.WebButton1Click(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );
end;

//====================================================================================================================//

procedure TfrmSchadenEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Opt_Speichern;
  inherited;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.WebFormCreate(Sender: TObject);
begin
  inherited;
  Opt_Laden;
end;

//====================================================================================================================//

procedure TfrmSchadenEdit.WebFormResize(Sender: TObject);
begin
  Form_Anpassen;
end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;



  // Komponenten
   iZielBreite := Trunc( self.Width * 0.95 );
   If iZielBreite > 500 then iZielBreite := 500;

   cbxBilder.Width := iZielBreite - cbxBilder.Left;

   fpFilePicker.Width := iZielBreite - fpFilePicker.Left;
   lbFahrzeug.Width  := iZielBreite - lbFahrzeug.Left;
   lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

   Console.Log('>> Form_Anpassen');
   lbDokumentPos.Left := cbxBilder.Left + cbxBilder.Width - lbDokumentPos.Width;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  self.sAktBild := '';

  Sprach_Daten_Laden('SCHADENEDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;


end;

//====================================================================================================================//

function TfrmSchadenEdit.Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
begin


//  Result := 'SELECT WERT FROM OPTIONEN';
//  exit;

  Result :=

  'SELECT T.DATUM, T.POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, T.INFO AS LADE_INFO, T.LADEGUT, '
  +' (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, T.ZEIT AS ZEIT_TXT,  '
  +'  '+cH+cH+' as ANSP_NAME, '  +'  '+cH+cH+' as ANSP_ZUNAME, '
  +'  '+cH+cH+' as ANSP_TEL, '+cH+cH + ' as ANSP_ANREDE '
  +' FROM TAU_ADR T, ADRESSE A WHERE T.ID_ADRESSE = A.ID_ADRESSE '
  +' AND T.ID_TAU ='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.BELADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.ENTLADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )


  +' ORDER BY 1 '; // T.DATUM, T.POS ' ;


end;

procedure TfrmSchadenEdit.ImgContrDblClick(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );


end;

//====================================================================================================================//

procedure TfrmSchadenEdit.pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
begin

  If aCurrentPageIndex = 1 then  Bild_Anzeigen;
  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmSchadenEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmSchadenEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmSchadenEdit');

//  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbNummer.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;





 self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmSchadenEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbSchadenCaption := TLabel.Create(Self);
  lbBeladung := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  edtSchadenRef := TLabel.Create(Self);
  lbMitarbeiter := TLabel.Create(Self);
  lbFahrzeug := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  pgContr := TTMSFNCPageControl.Create(Self);
  tabDaten := TTMSFNCPageControlContainer.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  lbStatus := TLabel.Create(Self);
  lbSchadensart := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  mBeschreibung := TMemo.Create(Self);
  edtDatum := TDateTimePicker.Create(Self);
  edtUhrzeit := TMaskEdit.Create(Self);
  tabDoku := TTMSFNCPageControlContainer.Create(Self);
  ImgContr := TImageControl.Create(Self);
  lbDokumentPos := TLabel.Create(Self);
  fpFilePicker := TFilePicker.Create(Self);
  cbxBilder := TComboBox.Create(Self);
  btnBildDel := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnAkt := TTMSFNCToolBarButton.Create(Self);
  btnDownload := TTMSFNCToolBarButton.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbSchadenCaption.BeforeLoadDFMValues;
  lbBeladung.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  edtSchadenRef.BeforeLoadDFMValues;
  lbMitarbeiter.BeforeLoadDFMValues;
  lbFahrzeug.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  pgContr.BeforeLoadDFMValues;
  tabDaten.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  lbStatus.BeforeLoadDFMValues;
  lbSchadensart.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  mBeschreibung.BeforeLoadDFMValues;
  edtDatum.BeforeLoadDFMValues;
  edtUhrzeit.BeforeLoadDFMValues;
  tabDoku.BeforeLoadDFMValues;
  ImgContr.BeforeLoadDFMValues;
  lbDokumentPos.BeforeLoadDFMValues;
  fpFilePicker.BeforeLoadDFMValues;
  cbxBilder.BeforeLoadDFMValues;
  btnBildDel.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnAkt.BeforeLoadDFMValues;
  btnDownload.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 580;
    Height := 567;
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 580;
    WebPanel1.Height := 119;
    WebPanel1.Align := alTop;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 0;
    lbSchadenCaption.SetParentComponent(WebPanel1);
    lbSchadenCaption.Name := 'lbSchadenCaption';
    lbSchadenCaption.Left := 157;
    lbSchadenCaption.Top := 5;
    lbSchadenCaption.Width := 69;
    lbSchadenCaption.Height := 18;
    lbSchadenCaption.Caption := 'Schaden';
    lbSchadenCaption.Font.Charset := DEFAULT_CHARSET;
    lbSchadenCaption.Font.Color := clBlack;
    lbSchadenCaption.Font.Height := -15;
    lbSchadenCaption.Font.Name := 'Verdana';
    lbSchadenCaption.Font.Style := [fsBold];
    lbSchadenCaption.HeightPercent := 100.000000000000000000;
    lbSchadenCaption.ParentFont := False;
    lbSchadenCaption.WidthPercent := 100.000000000000000000;
    lbBeladung.SetParentComponent(WebPanel1);
    lbBeladung.Name := 'lbBeladung';
    lbBeladung.Left := 16;
    lbBeladung.Top := 55;
    lbBeladung.Width := 59;
    lbBeladung.Height := 16;
    lbBeladung.Caption := 'Fahrzeug';
    lbBeladung.HeightPercent := 100.000000000000000000;
    lbBeladung.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 82;
    lbEntladung.Width := 71;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Mitarbeiter';
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.WidthPercent := 100.000000000000000000;
    edtSchadenRef.SetParentComponent(WebPanel1);
    edtSchadenRef.Name := 'edtSchadenRef';
    edtSchadenRef.Left := 157;
    edtSchadenRef.Top := 26;
    edtSchadenRef.Width := 88;
    edtSchadenRef.Height := 18;
    edtSchadenRef.Caption := 'S0000000';
    edtSchadenRef.Font.Charset := ANSI_CHARSET;
    edtSchadenRef.Font.Color := clWindowText;
    edtSchadenRef.Font.Height := -15;
    edtSchadenRef.Font.Name := 'Verdana';
    edtSchadenRef.Font.Style := [fsBold];
    edtSchadenRef.HeightPercent := 100.000000000000000000;
    edtSchadenRef.ParentFont := False;
    edtSchadenRef.WidthPercent := 100.000000000000000000;
    lbMitarbeiter.SetParentComponent(WebPanel1);
    lbMitarbeiter.Name := 'lbMitarbeiter';
    lbMitarbeiter.Left := 103;
    lbMitarbeiter.Top := 82;
    lbMitarbeiter.Width := 71;
    lbMitarbeiter.Height := 16;
    lbMitarbeiter.Caption := 'T0000000';
    lbMitarbeiter.Font.Charset := ANSI_CHARSET;
    lbMitarbeiter.Font.Color := clWindowText;
    lbMitarbeiter.Font.Height := -13;
    lbMitarbeiter.Font.Name := 'Verdana';
    lbMitarbeiter.Font.Style := [fsBold];
    lbMitarbeiter.HeightPercent := 100.000000000000000000;
    lbMitarbeiter.ParentFont := False;
    lbMitarbeiter.WidthPercent := 100.000000000000000000;
    lbFahrzeug.SetParentComponent(WebPanel1);
    lbFahrzeug.Name := 'lbFahrzeug';
    lbFahrzeug.Left := 103;
    lbFahrzeug.Top := 55;
    lbFahrzeug.Width := 71;
    lbFahrzeug.Height := 16;
    lbFahrzeug.Caption := 'T0000000';
    lbFahrzeug.Font.Charset := ANSI_CHARSET;
    lbFahrzeug.Font.Color := clWindowText;
    lbFahrzeug.Font.Height := -13;
    lbFahrzeug.Font.Name := 'Verdana';
    lbFahrzeug.Font.Style := [fsBold];
    lbFahrzeug.HeightPercent := 100.000000000000000000;
    lbFahrzeug.ParentFont := False;
    lbFahrzeug.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 72;
    btnOK.Top := 5;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    pgContr.SetParentComponent(Self);
    pgContr.Name := 'pgContr';
    pgContr.Left := 0;
    pgContr.Top := 119;
    pgContr.Width := 580;
    pgContr.Height := 448;
    pgContr.Align := alClient;
    pgContr.ParentDoubleBuffered := False;
    pgContr.Color := clBtnFace;
    pgContr.DoubleBuffered := True;
    pgContr.TabOrder := 1;
    pgContr.ActivePageIndex := 1;
    pgContr.Fill.Kind := gfkNone;
    pgContr.Fill.Color := 16776441;
    pgContr.Stroke.Kind := gskNone;
    pgContr.TabAppearance.Font.Charset := ANSI_CHARSET;
    pgContr.TabAppearance.Font.Color := clWindowText;
    pgContr.TabAppearance.Font.Height := -13;
    pgContr.TabAppearance.Font.Name := 'Verdana';
    pgContr.TabAppearance.Font.Style := [];
    pgContr.TabAppearance.Fill.Color := clWhite;
    pgContr.TabAppearance.ActiveFill.Color := 16639703;
    pgContr.TabAppearance.DownFill.Color := 15776936;
    pgContr.TabAppearance.DownStroke.Color := 15702829;
    pgContr.TabAppearance.HoverFill.Color := 16380654;
    pgContr.TabAppearance.HoverStroke.Color := 15702829;
    pgContr.TabAppearance.TextSpacing := 0.000000000000000000;
    pgContr.TabAppearance.ActiveTextColor := 4539717;
    pgContr.TabAppearance.HoverTextColor := 8026746;
    pgContr.TabAppearance.DownTextColor := 4539717;
    pgContr.TabAppearance.ShowFocus := False;
    pgContr.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    pgContr.TabAppearance.BadgeFont.Color := clDarkred;
    pgContr.TabAppearance.BadgeFont.Height := -11;
    pgContr.TabAppearance.BadgeFont.Name := 'Segoe UI';
    pgContr.TabAppearance.BadgeFont.Style := [fsBold];
    pgContr.ButtonAppearance.CloseIcon.LoadFromFile('SchadenEdit.pgContr.ButtonAppearance.CloseIcon.svg');
    pgContr.ButtonAppearance.InsertIcon.LoadFromFile('SchadenEdit.pgContr.ButtonAppearance.InsertIcon.svg');
    pgContr.ButtonAppearance.TabListIcon.LoadFromFile('SchadenEdit.pgContr.ButtonAppearance.TabListIcon.svg');
    pgContr.ButtonAppearance.ScrollNextIcon.LoadFromFile('SchadenEdit.pgContr.ButtonAppearance.ScrollNextIcon.svg');
    pgContr.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('SchadenEdit.pgContr.ButtonAppearance.ScrollPreviousIcon.svg');
    pgContr.BitmapContainer := BitmapCont;
    pgContr.Options.TabListButton := True;
    pgContr.TabSize.Mode := tsmFixedSize;
    pgContr.TabSize.Width := 120.000000000000000000;
    pgContr.TabSize.Height := 40.000000000000000000;
    pgContr.TabSize.Margins.Left := 8.000000000000000000;
    pgContr.TabSize.Margins.Top := 8.000000000000000000;
    pgContr.TabSize.Margins.Right := 8.000000000000000000;
    pgContr.TabSize.Margins.Bottom := 8.000000000000000000;
    pgContr.Pages.Clear;
    with pgContr.Pages.Add do
    begin
      Text := 'Daten';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Bilder';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    SetEvent(pgContr, Self, 'OnChangePage', 'pgContrChangePage');
    tabDaten.SetParentComponent(pgContr);
    tabDaten.Name := 'tabDaten';
    tabDaten.AlignWithMargins := True;
    tabDaten.Left := 0;
    tabDaten.Top := 47;
    tabDaten.Width := 580;
    tabDaten.Height := 401;
    tabDaten.Margins.Left := 0;
    tabDaten.Margins.Top := 47;
    tabDaten.Margins.Right := 0;
    tabDaten.Margins.Bottom := 0;
    tabDaten.Align := alClient;
    tabDaten.ParentDoubleBuffered := False;
    tabDaten.Color := 16776441;
    tabDaten.DoubleBuffered := True;
    tabDaten.TabStop := False;
    tabDaten.TabOrder := 1;
    tabDaten.Visible := False;
    tabDaten.Fill.Color := 16776441;
    tabDaten.PageIndex := 0;
    tabDaten.IsActive := False;
    WebLabel1.SetParentComponent(tabDaten);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 18;
    WebLabel1.Width := 42;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Datum';
    WebLabel1.Color := 16776441;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(tabDaten);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 201;
    WebLabel2.Top := 18;
    WebLabel2.Width := 46;
    WebLabel2.Height := 16;
    WebLabel2.Caption := 'Uhrzeit';
    WebLabel2.Color := 16776441;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(tabDaten);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 63;
    WebLabel3.Width := 50;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Status:';
    WebLabel3.Color := 16776441;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    lbStatus.SetParentComponent(tabDaten);
    lbStatus.Name := 'lbStatus';
    lbStatus.Left := 114;
    lbStatus.Top := 63;
    lbStatus.Width := 71;
    lbStatus.Height := 16;
    lbStatus.Caption := 'T0000000';
    lbStatus.Color := 16776441;
    lbStatus.Font.Charset := ANSI_CHARSET;
    lbStatus.Font.Color := clWindowText;
    lbStatus.Font.Height := -13;
    lbStatus.Font.Name := 'Verdana';
    lbStatus.Font.Style := [fsBold];
    lbStatus.HeightPercent := 100.000000000000000000;
    lbStatus.ParentFont := False;
    lbStatus.WidthPercent := 100.000000000000000000;
    lbSchadensart.SetParentComponent(tabDaten);
    lbSchadensart.Name := 'lbSchadensart';
    lbSchadensart.Left := 114;
    lbSchadensart.Top := 87;
    lbSchadensart.Width := 71;
    lbSchadensart.Height := 16;
    lbSchadensart.Caption := 'T0000000';
    lbSchadensart.Color := 16776441;
    lbSchadensart.Font.Charset := ANSI_CHARSET;
    lbSchadensart.Font.Color := clWindowText;
    lbSchadensart.Font.Height := -13;
    lbSchadensart.Font.Name := 'Verdana';
    lbSchadensart.Font.Style := [fsBold];
    lbSchadensart.HeightPercent := 100.000000000000000000;
    lbSchadensart.ParentFont := False;
    lbSchadensart.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(tabDaten);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 16;
    WebLabel6.Top := 87;
    WebLabel6.Width := 89;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Schadensart:';
    WebLabel6.Color := 16776441;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(tabDaten);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 118;
    WebLabel4.Width := 87;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Beschreibung';
    WebLabel4.Color := 16776441;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    mBeschreibung.SetParentComponent(tabDaten);
    mBeschreibung.Name := 'mBeschreibung';
    mBeschreibung.Left := 16;
    mBeschreibung.Top := 138;
    mBeschreibung.Width := 536;
    mBeschreibung.Height := 212;
    mBeschreibung.Anchors := [akLeft,akTop,akRight,akBottom];
    mBeschreibung.Font.Charset := ANSI_CHARSET;
    mBeschreibung.Font.Color := clWindowText;
    mBeschreibung.Font.Height := -13;
    mBeschreibung.Font.Name := 'Verdana';
    mBeschreibung.Font.Style := [];
    mBeschreibung.HeightPercent := 100.000000000000000000;
    mBeschreibung.ParentFont := False;
    mBeschreibung.SelLength := 0;
    mBeschreibung.SelStart := 0;
    mBeschreibung.WidthPercent := 100.000000000000000000;
    edtDatum.SetParentComponent(tabDaten);
    edtDatum.Name := 'edtDatum';
    edtDatum.Left := 74;
    edtDatum.Top := 12;
    edtDatum.Width := 111;
    edtDatum.Height := 28;
    edtDatum.Cursor := crHandPoint;
    edtDatum.BorderStyle := bsSingle;
    edtDatum.ChildOrder := 5;
    edtDatum.Color := 15329769;
    edtDatum.Date := 45767.262767685180000000;
    edtDatum.Role := '';
    edtDatum.ShowSeconds := False;
    edtDatum.Text := '';
    edtUhrzeit.SetParentComponent(tabDaten);
    edtUhrzeit.Name := 'edtUhrzeit';
    edtUhrzeit.Left := 255;
    edtUhrzeit.Top := 16;
    edtUhrzeit.Width := 63;
    edtUhrzeit.Height := 24;
    edtUhrzeit.EditMask := '!90:00;0;_';
    edtUhrzeit.MaxLength := 5;
    edtUhrzeit.TabOrder := 2;
    edtUhrzeit.Text := '';
    edtUhrzeit.HeightPercent := 100.000000000000000000;
    edtUhrzeit.WidthPercent := 100.000000000000000000;
    tabDoku.SetParentComponent(pgContr);
    tabDoku.Name := 'tabDoku';
    tabDoku.AlignWithMargins := True;
    tabDoku.Left := 0;
    tabDoku.Top := 47;
    tabDoku.Width := 580;
    tabDoku.Height := 401;
    tabDoku.Margins.Left := 0;
    tabDoku.Margins.Top := 47;
    tabDoku.Margins.Right := 0;
    tabDoku.Margins.Bottom := 0;
    tabDoku.Align := alClient;
    tabDoku.ParentDoubleBuffered := False;
    tabDoku.Color := 16776441;
    tabDoku.DoubleBuffered := True;
    tabDoku.TabStop := False;
    tabDoku.TabOrder := 0;
    tabDoku.Fill.Color := 16776441;
    tabDoku.PageIndex := 1;
    tabDoku.IsActive := True;
    ImgContr.SetParentComponent(tabDoku);
    ImgContr.Name := 'ImgContr';
    ImgContr.Left := 3;
    ImgContr.Top := 138;
    ImgContr.Width := 574;
    ImgContr.Height := 260;
    ImgContr.WidthStyle := ssAuto;
    ImgContr.HeightPercent := 100.000000000000000000;
    ImgContr.WidthPercent := 100.000000000000000000;
    ImgContr.Anchors := [akLeft,akTop,akRight,akBottom];
    ImgContr.ChildOrder := 1;
    SetEvent(ImgContr, Self, 'OnDblClick', 'ImgContrDblClick');
    lbDokumentPos.SetParentComponent(tabDoku);
    lbDokumentPos.Name := 'lbDokumentPos';
    lbDokumentPos.Left := 427;
    lbDokumentPos.Top := 35;
    lbDokumentPos.Width := 22;
    lbDokumentPos.Height := 16;
    lbDokumentPos.Caption := '0/0';
    lbDokumentPos.Color := 16776441;
    lbDokumentPos.HeightPercent := 100.000000000000000000;
    lbDokumentPos.WidthPercent := 100.000000000000000000;
    fpFilePicker.SetParentComponent(tabDoku);
    fpFilePicker.Name := 'fpFilePicker';
    fpFilePicker.Left := 14;
    fpFilePicker.Top := 96;
    fpFilePicker.Width := 497;
    fpFilePicker.Height := 36;
    fpFilePicker.Accept := 'image/*';
    fpFilePicker.ChildOrder := 1;
    SetEvent(fpFilePicker, Self, 'OnChange', 'fpFilePickerChange');
    SetEvent(fpFilePicker, Self, 'OnGetFileAsBase64', 'fpFilePickerGetFileAsBase64');
    cbxBilder.SetParentComponent(tabDoku);
    cbxBilder.Name := 'cbxBilder';
    cbxBilder.Left := 14;
    cbxBilder.Top := 57;
    cbxBilder.Width := 497;
    cbxBilder.Height := 24;
    cbxBilder.Cursor := crHandPoint;
    cbxBilder.HeightStyle := ssAuto;
    cbxBilder.HeightPercent := 100.000000000000000000;
    cbxBilder.WidthPercent := 100.000000000000000000;
    SetEvent(cbxBilder, Self, 'OnChange', 'cbxBilderChange');
    cbxBilder.ItemIndex := -1;
    btnBildDel.SetParentComponent(tabDoku);
    btnBildDel.Name := 'btnBildDel';
    btnBildDel.Left := 226;
    btnBildDel.Top := 7;
    btnBildDel.Width := 65;
    btnBildDel.Height := 44;
    btnBildDel.Cursor := crHandPoint;
    btnBildDel.ParentDoubleBuffered := False;
    btnBildDel.DoubleBuffered := True;
    btnBildDel.Font.Charset := ANSI_CHARSET;
    btnBildDel.Font.Color := clWindowText;
    btnBildDel.Font.Height := -13;
    btnBildDel.Font.Name := 'Verdana';
    btnBildDel.Font.Style := [];
    btnBildDel.ParentColor := True;
    btnBildDel.TabOrder := 2;
    SetEvent(btnBildDel, Self, 'OnClick', 'btnBildDelClick');
    btnBildDel.Text := '';
    btnBildDel.TextVisible := False;
    btnBildDel.Bitmaps.Clear;
    with btnBildDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnBildDel.BitmapVisible := True;
    btnBildDel.BitmapContainer := BitmapCont;
    btnBildDel.ControlIndex := 0;
    btnNavNext.SetParentComponent(tabDoku);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 81;
    btnNavNext.Top := 7;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 3;
    SetEvent(btnNavNext, Self, 'OnClick', 'DoDokumentNav');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavPrev.SetParentComponent(tabDoku);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 14;
    btnNavPrev.Top := 7;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 4;
    SetEvent(btnNavPrev, Self, 'OnClick', 'DoDokumentNav');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnAkt.SetParentComponent(tabDoku);
    btnAkt.Name := 'btnAkt';
    btnAkt.Left := 154;
    btnAkt.Top := 7;
    btnAkt.Width := 65;
    btnAkt.Height := 44;
    btnAkt.Cursor := crHandPoint;
    btnAkt.ParentDoubleBuffered := False;
    btnAkt.DoubleBuffered := True;
    btnAkt.Font.Charset := ANSI_CHARSET;
    btnAkt.Font.Color := clWindowText;
    btnAkt.Font.Height := -13;
    btnAkt.Font.Name := 'Verdana';
    btnAkt.Font.Style := [];
    btnAkt.ParentColor := True;
    btnAkt.TabOrder := 5;
    SetEvent(btnAkt, Self, 'OnClick', 'btnAktClick');
    btnAkt.Text := '';
    btnAkt.TextVisible := False;
    btnAkt.Bitmaps.Clear;
    with btnAkt.Bitmaps.Add do
    begin
      BitmapName := 'AKT';
    end;
    btnAkt.BitmapVisible := True;
    btnAkt.BitmapContainer := BitmapCont;
    btnAkt.ControlIndex := 0;
    btnDownload.SetParentComponent(tabDoku);
    btnDownload.Name := 'btnDownload';
    btnDownload.Left := 299;
    btnDownload.Top := 7;
    btnDownload.Width := 65;
    btnDownload.Height := 44;
    btnDownload.Cursor := crHandPoint;
    btnDownload.ParentDoubleBuffered := False;
    btnDownload.DoubleBuffered := True;
    btnDownload.Font.Charset := ANSI_CHARSET;
    btnDownload.Font.Color := clWindowText;
    btnDownload.Font.Height := -13;
    btnDownload.Font.Name := 'Verdana';
    btnDownload.Font.Style := [];
    btnDownload.ParentColor := True;
    btnDownload.TabOrder := 6;
    SetEvent(btnDownload, Self, 'OnClick', 'btnPdfClick');
    btnDownload.Text := '';
    btnDownload.TextVisible := False;
    btnDownload.Bitmaps.Clear;
    with btnDownload.Bitmaps.Add do
    begin
      BitmapName := 'DOWNLOAD';
    end;
    btnDownload.BitmapVisible := True;
    btnDownload.BitmapContainer := BitmapCont;
    btnDownload.ControlIndex := 0;
    tabSprachDaten.Left := 344;
    tabSprachDaten.Top := 24;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbSchadenCaption.AfterLoadDFMValues;
    lbBeladung.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    edtSchadenRef.AfterLoadDFMValues;
    lbMitarbeiter.AfterLoadDFMValues;
    lbFahrzeug.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    pgContr.AfterLoadDFMValues;
    tabDaten.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    lbStatus.AfterLoadDFMValues;
    lbSchadensart.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    mBeschreibung.AfterLoadDFMValues;
    edtDatum.AfterLoadDFMValues;
    edtUhrzeit.AfterLoadDFMValues;
    tabDoku.AfterLoadDFMValues;
    ImgContr.AfterLoadDFMValues;
    lbDokumentPos.AfterLoadDFMValues;
    fpFilePicker.AfterLoadDFMValues;
    cbxBilder.AfterLoadDFMValues;
    btnBildDel.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnAkt.AfterLoadDFMValues;
    btnDownload.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
